export default __webpack_public_path__ + "static/olympicPark4-cc701afbd4478d6a692ec6ecaea1c014.jpeg";